package kpt.core.base.database.infra.dao

import androidx.room3.EntityDeleteOrUpdateAdapter
import androidx.room3.EntityInsertAdapter
import androidx.room3.EntityUpsertAdapter
import androidx.room3.RoomDatabase
import androidx.room3.util.performSuspending
import androidx.sqlite.SQLiteStatement
import kotlin.Int
import kotlin.Long
import kotlin.String
import kotlin.Suppress
import kotlin.Unit
import kotlin.collections.List
import kotlin.reflect.KClass
import kpt.core.base.database.infra.entity.FetchedAtEntity

@Suppress(names = ["UNCHECKED_CAST", "DEPRECATION", "REDUNDANT_PROJECTION", "REMOVAL", "OPT_IN_USAGE_ERROR", "OPT_IN_USAGE", "MemberExtensionConflict", "CAN_BE_VAL"])
internal class FetchedAtDao_Impl(
  __db: RoomDatabase,
) : FetchedAtDao {
  private val __db: RoomDatabase

  private val __upsertAdapterOfFetchedAtEntity: EntityUpsertAdapter<FetchedAtEntity>
  init {
    this.__db = __db
    this.__upsertAdapterOfFetchedAtEntity = EntityUpsertAdapter<FetchedAtEntity>(object : EntityInsertAdapter<FetchedAtEntity>() {
      protected override fun createQuery(): String = "INSERT INTO `framework_fetched_at` (`storeKey`,`lastFetchedMillis`) VALUES (?,?)"

      protected override fun bind(statement: SQLiteStatement, entity: FetchedAtEntity) {
        statement.bindText(1, entity.storeKey)
        statement.bindLong(2, entity.lastFetchedMillis)
      }
    }, object : EntityDeleteOrUpdateAdapter<FetchedAtEntity>() {
      protected override fun createQuery(): String = "UPDATE `framework_fetched_at` SET `storeKey` = ?,`lastFetchedMillis` = ? WHERE `storeKey` = ?"

      protected override fun bind(statement: SQLiteStatement, entity: FetchedAtEntity) {
        statement.bindText(1, entity.storeKey)
        statement.bindLong(2, entity.lastFetchedMillis)
        statement.bindText(3, entity.storeKey)
      }
    })
  }

  public override suspend fun upsert(entity: FetchedAtEntity): Unit = performSuspending(__db, false, true) { _connection ->
    __upsertAdapterOfFetchedAtEntity.upsert(_connection, entity)
  }

  public override suspend fun read(storeKey: String): Long? {
    val _sql: String = "SELECT lastFetchedMillis FROM framework_fetched_at WHERE storeKey = ?"
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindText(_argIndex, storeKey)
        val _result: Long?
        if (_stmt.step()) {
          if (_stmt.isNull(0)) {
            _result = null
          } else {
            _result = _stmt.getLong(0)
          }
        } else {
          _result = null
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public companion object {
    public fun getRequiredColumnConverters(): List<KClass<*>> = emptyList()

    public fun getRequiredDaoReturnTypeConverters(): List<KClass<*>> = emptyList()
  }
}
